import { Formik } from "formik"
import { Turnstile } from "@marsidev/react-turnstile"
import { Logo } from "../../common/logo/logo"
import { Form } from "../../common/styles/forms"
import { GlobalStyle, Container } from "../../common/styles/global-style"
import { User } from "../../models/user"
import { userState } from "./signup.state"
import { Wrapper } from "./style"
import { useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { SignupUseCase } from "./application/usecases/signup.usecase"
import { ButtonPrimary, DescriptionBody, InputTextFormik, TitleBody } from "../../common"
import { urlsPages } from "../../common/urls/urls-pages"
import Swal from "sweetalert2"
import { ButtonDark } from "../../common/buttons/button-dark"

const siteKey = import.meta.env.VITE_TURNSTILE_SITE_KEY ?? ""

export const Signup = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const planId = searchParams.get('plan') ?? undefined
  const [loading, setLoading] = useState(false)
  const [turnstileToken, setTurnstileToken] = useState<string | null>(null)

  const handleSubmit = async (user: User, { resetForm }: any) => {
    if (!turnstileToken) return
    setLoading(true)
    const userCreated = await SignupUseCase.execute(user, turnstileToken, planId)
    if (!userCreated) {
      setLoading(false)
      resetForm()
      return Swal.fire({
        title: 'Error!',
        text: 'Erro ao criar usuário',
        icon: 'error',
        confirmButtonText: 'Ok'
      })
    }
    navigate(urlsPages.verifyEmail, { state: { email: user.email } })
    setLoading(false)
    resetForm()
    setTurnstileToken(null)
  }

  return (
    <>
      <GlobalStyle />
      <Container>
      <Logo center={true} margintop="40px"/>
        <Wrapper>
          <Formik
            initialValues={userState}
            onSubmit={handleSubmit}>
            <Form>
              <TitleBody>Crie sua conta</TitleBody>
              <DescriptionBody margintop="5px" marginbottom="20px">
                Digite seus dados para criar sua conta.
              </DescriptionBody>
              <InputTextFormik name="name" type="text" placeholder="Nome" required />
              <InputTextFormik name="email" type="email" placeholder="Email" required />
              <InputTextFormik name="password" type="password" placeholder="Senha" required />
              <Turnstile
                style={{ width: "100%" }}
                siteKey={siteKey}
                onSuccess={setTurnstileToken}
                onExpire={() => setTurnstileToken(null)}
                onError={() => setTurnstileToken(null)}
              />
              <ButtonPrimary
                width="100%"
                margintop="10px"
                marginbottom="30px"
                loading={loading}>
                Criar conta
              </ButtonPrimary>
              <ButtonDark width="100%" marginbottom="0" margintop="-10px" goToPage={urlsPages.signin}>
                Já tenho uma conta
              </ButtonDark>
            </Form>
          </Formik>
        </Wrapper>
      </Container>
    </>
  )
}